import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const BCVantaitable = React.memo(function BCVantaitable(props) {
  const classes = useStyles();
  const { data, khokhandexuat } = props;
  console.log(khokhandexuat);
  console.log(data);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th} style={{ width: "20%" }}>
            Chỉ tiêu
          </th>
          <th className={classes.tablebc_th} style={{ width: "70%" }}>
            Nội dung
          </th>
          <th className={classes.tablebc_th}>Ghi chú</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>Phương tiện</td>
          <td className={classes.tablebc_td}>
            Tổng số xe điện hiện có : 20 chiếc
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Lái xe</td>
          <td className={classes.tablebc_td}>
            Tổng số nhân viên lái xe : 30 người có giấy phép
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Phạm vi tuyến đường hoạt động</td>
          <td className={classes.tablebc_td}>
            Đến giai đoạn hiện nay Công ty đang đưa vào hoạt động phục vụ hành
            khách 03 tuyến đường trong nội thành thành phố Quy Nhơn
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Thời gian hoạt động</td>
          <td className={classes.tablebc_td}>
            Từ 5h 00’ đến 22h 00’ hàng ngày
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Giá cước</td>
          <td className={classes.tablebc_td}>
            Hiện tại theo giá cước niêm yết công khai trên xe, Công ty đang có 2
            hình thức tính tiền đối với hành khách đi xe như sau :
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>
            Bãi đỗ xe, xưởng bão dưỡng, sửa chữa xe
          </td>
          <td className={classes.tablebc_td}>
            Công ty hiện có 05 địa điểm tập kết phương tiện sau thời gian hoạt
            động gồm :
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>
            Các điểm dừng, đón trả khách tại khuôn viên của các nhà hàng, khách
            sạn, điểm du lịch
          </td>
          <td className={classes.tablebc_td}>
            Trước các khách sạn, khu nghĩ dưỡng nằm dọc các tuyến đường quy định
            và
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Tình hình thực hiện</td>
          <td className={classes.tablebc_td}>
            Trong năm hoạt động đơn vị đã nghiêm túc thực
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>
            nghĩa vụ với Ngân sách Nhà nước
          </td>
          <td className={classes.tablebc_td}>
            Hiện việc kê khai thuế GTGT, thuế TNDN, thực hiện đầy đủ...
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>
            Tổng số chuyến thực hiện dự kiến / kế hoạch ; tỷ lệ thực hiện/ kế
            hoạch
          </td>
          <td className={classes.tablebc_td}>
            Tổng số chuyến :23,040/22,000 Đạt tỷ lệ 105% so với kế hoạch đề ra
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Khối lượng vận chuyển (người)</td>
          <td className={classes.tablebc_td}>122,500 người</td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>
            Khối lượng luân chuyển (người.km)
          </td>
          <td className={classes.tablebc_td}>92,160 người.km</td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Doanh thu khai thác</td>
          <td className={classes.tablebc_td}>4,8 tỷ/ năm</td>
          <td className={classes.tablebc_td}></td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>Kiến nghị, đề xuất của đơn vị</td>
          <td className={classes.tablebc_td}>
            -Đơn vị kiến nghị xin cấp phép kinh doanh thêm...
          </td>
          <td className={classes.tablebc_td}></td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div>
      <table className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCVantaitable.propTypes = {
  data: PropTypes.object,
  khokhandexuat: PropTypes.object,
};
export default BCVantaitable;
